'use es6';

import { Fragment } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { propertyCanHaveGlobalDefaultValue, i18nKey } from '../../../utils/properties';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Fallback({
  currentOption,
  isGlobalFallback,
  setIsGlobalFallback,
  fallback,
  setFallback,
  settingsLink,
  tooltipClassName,
  handleInsertToken
}) {
  const handleGlobalFallbackChange = ({
    target: {
      checked
    }
  }) => {
    setIsGlobalFallback(checked);
    if (checked) {
      setFallback('');
    }
  };
  const handleSubmitOnEnter = evt => {
    if (evt.key === 'Enter') {
      handleInsertToken(currentOption);
    }
  };
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(FormControl, {
      marginBlockStart: "0",
      label: I18n.text(i18nKey('fallbackLabel')),
      tooltip: I18n.text(i18nKey('fallbackHelp')),
      tooltipPlacement: "top right",
      tooltipProps: {
        innerClassName: tooltipClassName
      },
      children: /*#__PURE__*/_jsx(TextInput, {
        "data-test-id": "local-fallback-input",
        value: fallback,
        disabled: isGlobalFallback === true,
        onChange: ({
          target: {
            value
          }
        }) => setFallback(value),
        onKeyDown: handleSubmitOnEnter
      })
    }), propertyCanHaveGlobalDefaultValue(currentOption) && /*#__PURE__*/_jsx(Checkbox, {
      marginBlockStart: "200",
      size: "small",
      checked: isGlobalFallback,
      onChange: handleGlobalFallbackChange,
      "data-test-id": "default-value-global-checkbox",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        options: {
          href: settingsLink
        },
        message: i18nKey('globalFallbackLabelHelp')
      })
    })]
  });
}
Fallback.propTypes = {
  setFallback: PropTypes.func.isRequired,
  setIsGlobalFallback: PropTypes.func.isRequired,
  settingsLink: PropTypes.string.isRequired,
  currentOption: PropTypes.object,
  isGlobalFallback: PropTypes.bool,
  fallback: PropTypes.string,
  tooltipClassName: PropTypes.string,
  handleInsertToken: PropTypes.func.isRequired
};